import React, { useContext, useEffect, useState } from 'react';
import './SignIn.css';
import config from '../../config';
import { inputOnlyNumbers } from '../../utils/CommonUtilities';
import { AuthContext } from '../../contexts/authContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import SySbackground from '../../components/SySbackground/SySbackground';
import CircleProgress from '../../components/CircleProgress/CircleProgress';
import SysCubeLogo from '../../assets/svgs/systrategy_cube_logo.svg';
import sysLogo from '../../assets/svgs/systrategy_logo.svg';
import condeLogo from '../../assets/svgs/condenast.svg'
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { VisibilityIcon, VisibilityOffIcon, KeyIcon, AccountCircleIcon, ArrowDown } from '../../assets/icons/icons';

function SignIn() {
	const auth = useContext(AuthContext);
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [showPassword, setShowPassword] = useState(false);
	const [signinLoading, setSigninLoading] = useState(false);
	const [openDialogMFA, setOpenDialogMFA] = useState(false);
	const [codeTOTP, setCodeTOTP] = useState('');
	const [searchParams, setSearchParams] = useSearchParams();
	const [openOperatorLogin, setOpenOperatorLogin] = useState(false);

	useEffect(() => {
		if(searchParams.get("out")!=='userRequest'){
			mylogin();
		}
	},[])

	const signIn = async(event) => {
		event.preventDefault();
		setSigninLoading(true);
		try{
			let response = await auth.signInWithEmail(email, password);
			if(response === 'SOFTWARE_TOKEN_MFA'){
				setOpenDialogMFA(true);
				setSigninLoading(false);
			}else{
				navigate(config.HOME_PAGE);
				setSigninLoading(false);
			}
		}catch(e){
			if(e instanceof Error){
				setSigninLoading(false);
				//notifica di credenziali errate diretta nel caso in cui l'mfa non sia obbligatorio
				NotificationManager.error('Credenziali Errate', 'Login Fallito', config.DEFAULT_TIMEOUT_POPUPS)
			}else{
				setSigninLoading(false);
				//altrimenti forzo lo stesso il popup anche da credenziali errate
				setOpenDialogMFA(true);
			}
		}
	}

	const btnEnabled = (email !== '' && password !== '');

	const handleCloseDialog = () => {
		setCodeTOTP('');
		setOpenDialogMFA(false);
	}

	const submitTOTP = async(event = false) => {
		if(event)event.preventDefault();
		setSigninLoading(true);
		handleCloseDialog();
		try{
			await auth.signInWithTOTP(codeTOTP, email, password);
			setSigninLoading(false);
			navigate(config.HOME_PAGE);
		}catch(e){
			setSigninLoading(false);
			NotificationManager.error('Credenziali Errate', 'Login Fallito', config.DEFAULT_TIMEOUT_POPUPS);
		}
	}

	const mylogin = () => {
		//window.location.href="https://google.com"
		window.location.href=`${config.COGNITO_DOMAIN_URL}/oauth2/authorize?identity_provider=${config.COGNITO_SAML_PROVIDER}&redirect_uri=${config.FE_URL}/login-callback&response_type=CODE&client_id=${config.REACT_APP_CLIENT_ID}&scope=email openid phone aws.cognito.signin.user.admin&code_challenge=Eh0mg-OZv7BAyo-tdv_vYamx1boOYDulDklyXoMDtLg&code_challenge_method=S256`
	}

	return (
		<div className='signin'>
			{signinLoading && (<CircleProgress isDialog={true}/>)}
			<div className='signin-container'>
				<div className="signin-content">
					<div className="app-login-header">
						<span className="login-name-app-1">SYSTRATEGY</span>
						<span className="login-name-app-2"> HUB</span>	
					</div>
					<div className="user-psw-container">
						<p>
							Dear user if you are not redirected to the login page within 5 seconds please click the button.
						</p>
						<div className="button-wrapper">
							<Button
								variant = "outlined"
								className   ={ "text-uppercase signin-btn" }
								onClick={mylogin}
							>LOGIN With Okta</Button>
						</div>
					</div>
					<div className="footer-info top-bottom-section">
						<a href="https://www.systrategy.it" target="_blank" rel="noreferrer">
							<img
								src         ={sysLogo}
								alt         ="Systrategy"
								draggable   ="false"
								className   ="systrategy-logo"
							/>
						</a>
						<IconButton onClick={() => setOpenOperatorLogin(!openOperatorLogin)}><ArrowDown addClass={`pointer font-12 open-operator-arrow ${openOperatorLogin ? 'opened' : ''}`}></ArrowDown></IconButton>
						<img width={150} src={condeLogo}></img>
					</div>
				</div>
				<div className={`operator-login ${openOperatorLogin ? 'opened' : ''}`}>
					<p>Operator Login</p>
					<Input
						name            ="email"
						value           ={ email }
						placeholder     ="Email"
						type			="text"
						spellCheck      ={ false }
						onChange        ={ e => { setEmail(e.target.value); } }
						startAdornment  = {
							<InputAdornment position="start">
								<AccountCircleIcon/>
							</InputAdornment>
						}
					/>
					<Input
						name            ="password"
						id              ="password"
						placeholder     ="Password"
						type            ={ showPassword ? 'text' : 'password' }
						value           ={ password }
						onChange        ={ e => { setPassword(e.target.value); } }
						spellCheck      ={ false }
						startAdornment  ={
							<InputAdornment position="start">
								<KeyIcon />
							</InputAdornment>
						}
						endAdornment    ={
							<InputAdornment position="end">
								<IconButton
									aria-label ="toggle password visibility"
									onClick    ={ e => { setShowPassword(!showPassword); } }
								>
									{ showPassword ? <VisibilityIcon addClass='font-18'/> : <VisibilityOffIcon addClass='font-18'/> }
								</IconButton>
							</InputAdornment>
						}
					/>
					<Button
						variant     = "outlined"
						className   ={ "text-uppercase signin-btn" }
						disabled    ={ !btnEnabled }
						onClick={signIn}
					>LOGIN</Button>
				</div>
			</div>
			<Dialog open={openDialogMFA} onClose={handleCloseDialog}>
				<DialogTitle>Multi-Factor Authentication</DialogTitle>
				<DialogContent className='align-mfa-center'>
					<DialogContentText className='font-12'>
						Open your authentication app and enter a MFA code to complete sign-in
					</DialogContentText>
					<form onSubmit={(event) =>submitTOTP(event)}>
						<FormControl className="signin-credentials-wrapper">
							<OutlinedInput
								className       ="center-text font-24"
								autoComplete='off'
								name            ="totp"
								id              ="totp"
								placeholder     ="Code"
								type            ='text'
								inputProps		={{maxLength: 6}}
								value           ={ codeTOTP }
								onChange        ={ e => { if(inputOnlyNumbers(e.target.value))setCodeTOTP(e.target.value); } }
								spellCheck      ={ false }
								autoFocus
							/>
						</FormControl>
					</form>
				</DialogContent>
				<DialogActions className='flex-box-between'>
					<Button onClick={handleCloseDialog}>Annulla</Button>
					<Button onClick={submitTOTP} variant='contained'>Conferma</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}

export default SignIn;